// extracted by mini-css-extract-plugin
export default {"h1":"styles_h1__JRoIo","h2":"styles_h2__SLNmU","h3":"styles_h3__yUhPw","h4":"styles_h4__1s4IT","h6":"styles_h6__FPEMX","span":"styles_span__vdk9Z","p":"styles_p__4rIy1"};